// product grid/list
// function listgridJavascript() {
// Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
//     link.addEventListener('click', function(event) {
//         Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
//         this.classList.add('active');
//         if(this.classList.contains('listv')){
//             document.getElementById('product-grid').classList.add('product-list');
//             document.getElementById('product-grid').classList.remove('product-grid');
//         }else if(this.classList.contains('gridv')){
//             document.getElementById('product-grid').classList.add('product-grid');
//             document.getElementById('product-grid').classList.remove('product-list');
//         }
//     });
// });
// };
// document.addEventListener("shopify:section:load", listgridJavascript);
// listgridJavascript();


function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}
/*
 * Search modal: default (empty-query) panel.
 *
 * Perf: this panel — quick links, search menu, popular-products grid — used to be inlined in
 * header.liquid inside a container that starts out `hidden`. It measured 42.8 KB, 7.5% of the
 * homepage HTML, and all of it preceded the LCP image in the document, so the preload scanner
 * had to stream past it before it could discover the hero. Lighthouse measured LCP "resource
 * load delay" at 709-1025 ms, the largest and most variable slice of LCP on this theme.
 *
 * It is now pulled in through the Section Rendering API instead. The fetch runs on idle after
 * load, so it costs nothing on the critical path and is normally in the DOM long before anyone
 * opens search. Opening search before it lands triggers the fetch immediately rather than
 * waiting for idle, so the panel is never missing — only, rarely, a few hundred ms late.
 *
 * Section: sections/search-default-panel.liquid
 */
(function () {
  var TARGET = '[data-default-search-panel]';
  var markup = null; // section HTML, cached after the first successful fetch
  var pending = false; // a fetch is in flight

  function targets() {
    return Array.prototype.slice.call(document.querySelectorAll(TARGET));
  }

  // Filling a container also clears its marker attribute, so it drops out of targets() and is
  // never filled twice.
  function fill(nodes) {
    nodes.forEach(function (node) {
      node.innerHTML = markup;
      node.removeAttribute('data-default-search-panel');
    });

    // PredictiveSearch.initResize() runs in the element's constructor and observes
    // .wbsrightpart, which lives in this panel (snippets/predictive-search-default.liquid).
    // Because the panel now arrives after that constructor has run, the element was not in the
    // DOM to observe, so the IntersectionObserver watched nothing and .seachbar-left never got
    // its max-height matched to the right-hand column. Re-running initResize() now that the
    // markup exists restores it. The panel is still inside a `hidden` container at this point,
    // so the measurement is 0 and the observer is what actually applies the height when the
    // shopper opens search - which is exactly the path that was broken.
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (typeof ps.initResize === 'function') ps.initResize();
    });
  }

  function load() {
    var nodes = targets();
    if (!nodes.length) return;
    if (markup !== null) {
      fill(nodes);
      return;
    }
    if (pending) return;
    pending = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + '?section_id=search-default-panel', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        // The Section Rendering API wraps output in <div id="shopify-section-{name}">; we want
        // that div's children, not the wrapper. predictive-search.js reads the same shape.
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var wrapper =
          parsed.getElementById('shopify-section-search-default-panel') ||
          parsed.querySelector('.shopify-section') ||
          parsed.body;
        if (!wrapper || !wrapper.innerHTML.trim()) throw new Error('empty section');

        pending = false;
        markup = wrapper.innerHTML;
        fill(targets());
      })
      .catch(function () {
        // Leaving the container empty is a survivable outcome: search itself is unaffected,
        // the shopper just sees no suggestions until they type. markup stays null and pending
        // goes back to false, so the next interaction retries.
        pending = false;
      });
  }

  // Fetch when the browser is otherwise idle, so this never competes with the hero image.
  function scheduleIdleLoad() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        load();
      }, { timeout: 3000 });
    } else {
      setTimeout(load, 1200);
    }
  }

  if (document.readyState === 'complete') {
    scheduleIdleLoad();
  } else {
    window.addEventListener('load', scheduleIdleLoad, { once: true });
  }

  // If a shopper reaches for search before idle time arrives, stop waiting.
  ['focusin', 'click'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (pending) return;
        var el = event.target;
        if (el && el.closest && el.closest('predictive-search, .search-modal, [id^="Details-search"]')) {
          load();
        }
      },
      true
    );
  });

  // The theme editor re-renders a whole section on every settings change, which hands us a fresh
  // and empty panel container. Without this the merchant sees an empty search modal for the rest
  // of the editing session. Fires only in the editor, and refills from the cache - no new fetch.
  document.addEventListener('shopify:section:load', function () {
    load();
  });
})();
